export default function Details({ user: theCurrentUser, me } = {}) {
  return <h1>Role Details</h1>;
}
